"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var icon_1 = require("../icon");
var itemsList_1 = require("../itemsList");
var react_transition_group_1 = require("react-transition-group");
var ButtonsList = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonsList, _super);
    function ButtonsList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onClick = function (e) {
            _this.setState({
                isOpen: !_this.state.isOpen
            });
        };
        _this.setRef = function (el) {
            _this.$el = el;
        };
        _this.setListRef = function (el) {
            _this.$list = el;
        };
        _this.$el = null;
        _this.$list = null;
        _this.state = { isOpen: false };
        _this.onWindowScroll = utils_1.debounce(_this.onWindowScroll, 100).bind(_this);
        _this.onDocumentClick = _this.onDocumentClick.bind(_this);
        return _this;
    }
    ButtonsList.prototype.getMouseEventMap = function () {
        return {
            click: this.onDocumentClick
        };
    };
    ButtonsList.prototype.onDocumentClick = function (e) {
        var isOpen = this.state.isOpen;
        if (this.isClickOutside(e.target) && isOpen) {
            this.setState({ isOpen: false });
        }
    };
    ButtonsList.prototype.componentDidMount = function () {
        utils_1.addEventsToDocument(this.getMouseEventMap());
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    ButtonsList.prototype.componentWillUnmount = function () {
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
        window.removeEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    ButtonsList.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.state.isOpen && !prevState.isOpen) {
            this.setPosition();
        }
    };
    ButtonsList.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.echo !== this.props.echo && this.state.isOpen) {
            this.setState({ isOpen: false });
        }
    };
    ButtonsList.prototype.isClickOutside = function (target) {
        return !this.$el
            ? true
            : !this.$el.contains(target) && (!this.$list ? true : !this.$list.contains(target));
    };
    ButtonsList.prototype.onWindowScroll = function () {
        if (this.state.isOpen) {
            this.setPosition();
        }
    };
    ButtonsList.prototype.setPosition = function () {
        var _this = this;
        utils_1.raf(function () {
            var horizontalPositionCssProp = "right";
            var verticalPositionCssProp = "top";
            if (_this.$list) {
                var elRect = _this.$el.getBoundingClientRect();
                var listRect = _this.$list.getBoundingClientRect();
                if (window.pageYOffset + window.innerHeight < elRect.top + window.pageYOffset + elRect.height + listRect.height) {
                    verticalPositionCssProp = "bottom";
                }
                if (elRect.left + elRect.width - listRect.width < 0) {
                    horizontalPositionCssProp = "left";
                }
            }
            if (horizontalPositionCssProp !== _this.state.horizontalPositionCssProp ||
                verticalPositionCssProp !== _this.state.verticalPositionCssProp) {
                _this.setState({
                    verticalPositionCssProp: verticalPositionCssProp,
                    horizontalPositionCssProp: horizontalPositionCssProp
                });
            }
        });
    };
    ButtonsList.prototype.createClickWrapper = function (onClick, name) {
        var _this = this;
        return function (e) {
            e.currentTarget.name = name;
            _this.onClick(e);
            onClick && onClick(e);
        };
    };
    ButtonsList.prototype.convertButtonsToListItems = function (children) {
        var _this = this;
        return React.Children.map(children, function (child, i) {
            if (child && child.type.displayName === "Button") {
                var props = {
                    label: child.props.children,
                    iconName: child.props.iconName,
                    onClick: _this.createClickWrapper(child.props.onClick, child.props.name),
                    disabled: child.props.disabled,
                    innerRef: child.props.innerRef
                };
                return (React.createElement(itemsList_1.ListItem, tslib_1.__assign({}, props)));
            }
            if (child && child.props && React.Children.toArray(child.props.children).length > 0) {
                return _this.convertButtonsToListItems(child.props.children);
            }
            return null;
        });
    };
    ButtonsList.prototype.renderListItems = function () {
        var _a;
        var _b = this.props, theme = _b.theme, maxItems = _b.maxItems, children = _b.children;
        var isOpen = this.state.isOpen;
        var _c = this.state, verticalPositionCssProp = _c.verticalPositionCssProp, horizontalPositionCssProp = _c.horizontalPositionCssProp;
        var wrapperStyles = (_a = {},
            _a[verticalPositionCssProp] = "100%",
            _a[horizontalPositionCssProp] = 0,
            _a);
        var itemsListProps = {
            maxItems: maxItems
        };
        var listItems = this.convertButtonsToListItems(children);
        return (React.createElement("div", { className: theme.list, style: wrapperStyles, ref: this.setListRef },
            React.createElement(itemsList_1.ItemsList, tslib_1.__assign({}, itemsListProps), utils_1.compact(utils_1.flatten(listItems)))));
    };
    ButtonsList.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, children = _b.children, label = _b.label, disabled = _b.disabled, fill = _b.fill, echo = _b.echo;
        if (echo) {
            return children;
        }
        var isOpen = this.state.isOpen;
        var classes = classnames_1.default(theme.buttonsList, className, (_a = {},
            _a[theme.open] = isOpen,
            _a[theme.disabled] = disabled,
            _a[theme.fill] = fill,
            _a));
        return (React.createElement("div", { className: classes, ref: this.setRef },
            React.createElement("button", { type: "button", className: theme.handler, onClick: this.onClick, disabled: disabled },
                React.createElement("div", { className: theme.label }, label),
                React.createElement(icon_1.Icon, { className: theme.icon, size: 1, iconName: "icon-arrow-down-small" })),
            React.createElement(react_transition_group_1.CSSTransition, { unmountOnExit: true, in: isOpen, classNames: {
                    enter: theme.listEnter,
                    enterActive: theme.listEnterActive,
                    exit: theme.listLeave,
                    exitActive: theme.listLeaveActive
                }, timeout: 200 }, this.renderListItems())));
    };
    ButtonsList.defaultProps = {};
    return ButtonsList;
}(React.Component));
exports.default = ButtonsList;
